
const breakpoints = ["base", "xs", "sm", "md", "lg", "wall", "ss"];

function isBreakpoint(breakpoint) {
  var beacon = document.getElementById("js-" + breakpoint + "-beacon");
  if (beacon) {
    return beacon.offsetWidth > 0;
  }
  return false;
}

export function getBreakpoint() {
  for (var i = 0; i < breakpoints.length; i++) {
    if (isBreakpoint(breakpoints[i])) {
      return breakpoints[i];
    }
  }
  return "base";
}

export function isMobile() {
  return isBreakpointLessThan(getBreakpoint(), "sm");
}

export function isBreakpointGreaterThan(b1, b2) {
  var idx1 = breakpoints.indexOf(b1);
  var idx2 = breakpoints.indexOf(b2);
  return idx1 > idx2;
}

export function isBreakpointLessThan(b1, b2) {
  var idx1 = breakpoints.indexOf(b1);
  var idx2 = breakpoints.indexOf(b2);
  return idx1 < idx2;
}
